module.exports = __webpack_public_path__ + "img/csr_111123_A.d0eb84fe.jpg";